import { render, staticRenderFns } from "./e-mail-detail.vue?vue&type=template&id=04cc6316&"
import script from "./e-mail-detail.vue?vue&type=script&lang=js&"
export * from "./e-mail-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports